import {
  getCatalogCategories,
  getCollectionData,
  getFeatureLocks,
  getSEODetails,
} from '../services';

/**
 * @typedef {Object} SSRCollectiveData
 * @property {any} collections
 * @property {any} catalogCategories
 * @property {any} catalogTags
 * @property {any} seo
 */

/**
 * this function is for all common api calls used in SSR.
 * @param {Array} callType api calls to make
 * @param {Object} reducerState reducerState object sent as argument
 * @return {Promise<SSRCollectiveData>} object contains all api call response
 */
export async function ssrCollectiveCall(callType, reducerState) {
  /**
   * @type {SSRCollectiveData}
   */
  let propType = {};
  const storeId = reducerState?.data?.store?.store_id;

  /*
    if store_id is non-empty, then go forth with the api calls
  */
  if (!callType?.length || !storeId) return propType;

  let featureLocks = reducerState?.data?.featureLocks;
  if (!featureLocks) {
    const { data } = await getFeatureLocks(storeId);
    featureLocks = data;
  }

  const promArr = [null, null, null];
  callType.forEach((type) => {
    switch (type) {
      case 'collections': {
        const isCollectionFeatureUnlocked = !featureLocks?.['collections']?.is_locked;
        if (isCollectionFeatureUnlocked) {
          promArr[0] = getCollectionData(storeId);
        }
        break;
      }
      case 'categories':
        if (storeId) {
          promArr[1] = getCatalogCategories(storeId);
        }
        break;
      case 'seo':
        const isSeoFeatureUnlocked = !featureLocks?.['seo']?.is_locked;
        if (
          storeId &&
          reducerState?.data?.store?.domain_info?.domain_type !== 0 &&
          !!isSeoFeatureUnlocked
        ) {
          promArr[2] = getSEODetails(storeId);
        }
        break;
      default:
        break;
    }
  });

  const fetchData = await Promise.all(promArr);

  const collections = fetchData[0]?.data?.status
    ? JSON.parse(fetchData[0]?.data?.data || [])
    : [];
  const catalogCategories = fetchData[1]?.data?.status
    ? fetchData[1]?.data?.store_categories || []
    : [];
  const catalogTags = fetchData[1]?.data?.status
    ? fetchData[1]?.data?.tags?.filter((tag) => tag?.is_active === 1) || []
    : [];
  const seo = fetchData[2]?.data?.status
    ? JSON.parse(fetchData[2]?.data?.data || {})
    : null;

  propType = { collections, catalogCategories, catalogTags, seo };

  return propType;
}

export const ssrDataCall = (callType, storeData, featureLocks = null) => {
  return ssrCollectiveCall(callType, { data: { store: storeData, featureLocks } });
};
